export const abdykhadirov = {
    id: "abdykhadirov",
    name: { ru: "Абдыхадиров Данияр Нурланович", kz: "Абдыхадиров Данияр Нұрланұлы" },
    position: { ru: "Заместитель руководителя по медицинской части, врач спортивной медицины", kz: "Медициналық істер жөніндегі басшының орынбасары, спорттық медицина дәрігері" },
    department: "specialists",
    image: "/team_photoes/new/abdykhadirov.jpeg",
    education: {
      ru: `2006–2012 — АО «Медицинский университет Астана», факультет «Лечебное дело»
2012–2013 — АО «Медицинский университет Астана», интернатура по специальности «Терапия»`,
      kz: `2006–2012 — «Астана медициналық университеті» АҚ, «Емдеу ісі» факультеті
2012–2013 — «Астана медициналық университеті» АҚ, «Терапия» мамандығы бойынша интернатура`
    },
    specialization: {
      ru: `Терапия
Подростковая терапия
Диетология
Неотложная медицинская помощь
Инфекционные заболевания
Спортивная медицина`,
      kz: `Терапия
Жасөспірімдерге арналған терапия
Диетология
Жедел медициналық көмек
Жұқпалы аурулар
Спорттық медицина`
    },
        work: {
    ru: `• 2014–2016 — Начальник медицинского пункта, Войсковая часть 61993
- 2016–2017 — Заведующий отделением УВОВ, Городская поликлиника №4
- 2017–2018 — Участковый терапевт, Городская поликлиника №4
- 2018–2021 — Заведующий отделением скорой медицинской помощи, Городская поликлиника №4
- 2021 — Заведующий инфекционного отделения, Многопрофильный медицинский центр
- 2021–2022 — Заведующий инфекционного отделения, Городской центр фтизиопульмонологии
- 2022–2025 — Врач-терапевт, Городская поликлиника №9
- 2025 — Заведующий отделением по профилю, Спортивный медицинский центр города Астана
- 2025 — по настоящее время — Заместитель руководителя по медицинской части, Спортивный медицинский центр города Астана
- 2025 — по настоящее время — Врач спортивной медицины, Спортивный медицинский центр города Астана`,
    kz: `• 2014–2016 — Медициналық пункт басшысы, 61993 әскери бөлімі
- 2016–2017 — ҰОСМ ардагерлері бөлімінің меңгерушісі, №4 қалалық емхана
- 2017–2018 — Учаскелік терапевт, №4 қалалық емхана
- 2018–2021 — Жедел медициналық жәрдем бөлімінің меңгерушісі, №4 қалалық емхана
- 2021 — Жұқпалы аурулар бөлімінің меңгерушісі, Көпсалалы медициналық орталық
- 2021–2022 — Жұқпалы аурулар бөлімінің меңгерушісі, Қалалық фтизиопульмонология орталығы
- 2022–2025 — Терапевт-дәрігер, №9 қалалық емхана
- 2025 — Бейіні бойынша бөлім меңгерушісі, Астана қаласының спорттық медициналық орталығы
- 2025 — қазіргі уақытқа дейін — Медициналық істер жөніндегі басшының орынбасары, Астана қаласының спорттық медициналық орталығы
- 2025 — қазіргі уақытқа дейін — Спорттық медицина дәрігері, Астана қаласының спорттық медициналық орталығы`,
  },
certificates: {
    ru: `Сертификаты и квалификация:
- Сертификат по терапии (до 19.09.2030)
- Высшая квалификационная категория по терапии (до 19.09.2030)
- Сертификат по спортивной медицине (до 20.06.2030)

Повышение квалификации:
- 2019 — «Лидерство и управление человеческими ресурсами» (216 часов)
- 2020 — «Неотложные состояния в терапии» (54 часа)
- 2020 — «Наследственные заболевания нервной системы» (162 часа)
- 2020 — «Эмоциональный интеллект»
- 2021 — «Инфекционные болезни в условиях глобализации: вызовы и решения» (20 часов)
- 2022 — «Современные диагностические критерии и принципы лечения ревматических заболеваний» (120 часов)
- 2025 — Сертификационный курс «Спортивная медицина» (720/24 часов/кредитов)`,
    kz: `Сертификаттар және біліктілік:
- Терапия мамандығы бойынша сертификат (19.09.2030 дейін)
- Терапия мамандығы бойынша жоғары біліктілік санаты (19.09.2030 дейін)
- Спорттық медицина бойынша сертификат (20.06.2030 дейін)

Біліктілікті арттыру:
- 2019 — «Көшбасшылық және адам ресурстарын басқару» (216 сағат)
- 2020 — «Терапиядағы жедел жағдайлар» (54 сағат)
- 2020 — «Жүйке жүйесінің тұқым қуалайтын аурулары» (162 сағат)
- 2020 — «Эмоционалды интеллект»
- 2021 — «Жаһандану жағдайындағы жұқпалы аурулар: сын-қатерлер мен шешімдер» (20 сағат)
- 2022 — «Ревматикалық аурулардың заманауи диагностикалық критерийлері және емдеу принциптері» (120 сағат)
- 2025 — «Спорттық медицина» сертификаттау курсы (720/24 сағат/кредит)`,
  }
  };
